module.exports = __webpack_public_path__ + "img/bottom.94c09a74.jpg";